import GeoAddress from "../../types/GeoAddress";
import countryListOptions from "../country-options.json";

const getFormattedAddressForUi = (address?: GeoAddress): string => {
  if (!address) {
    return "";
  }
  const country =
    countryListOptions.find(({ value }) => value === address.countryCode)?.label ??
    address.countryCode;

  return [
    address.address,
    address.city,
    // Do not put region if it matches the city. Improves readability
    address.city === address.region ? "" : address.region,
    address.fullPostalCode ?? address.postalCode,
    country,
  ]
    .filter((part) => !!part)
    .join(", ");
};
export default getFormattedAddressForUi;
